import React from "react"
import { formatCount } from "~/common/number-utils"
import { AppText } from "~/ui/app-text"

interface ReactionGroup {
  emoji: string
  reactionCount: number
}

interface MessageReactionsProps {
  reactionGroups: ReactionGroup[] | null | undefined
}

export const MessageReactions: React.FC<MessageReactionsProps> = ({ reactionGroups }) => {
  if (!reactionGroups || reactionGroups.length === 0) {
    return null
  }

  return (
    <>
      {reactionGroups.slice(0, 3).map((reaction, reactionIndex) => {
        const emoji = reaction.emoji || "❤️"

        return (
          <div
            key={reactionIndex}
            className="border-white/56 flex h-6 items-center gap-1 rounded-full border px-2 shadow-sm"
          >
            <AppText variant="caption" className="text-base-black">
              {emoji}
            </AppText>
            <AppText variant="caption" className="text-base-black">
              {formatCount(reaction.reactionCount)}
            </AppText>
          </div>
        )
      })}
    </>
  )
}
